export default "__VITE_ASSET__uPjnHcLY__"